import { ConnectedRouter } from "connected-react-router";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { UIService } from "src/services";
import {
  ConfigInit,
  ConfigInitAction,
  HttpCacheAction,
  UserSessionAction,
  history,
} from "src/store";
import Mobile from "../containers/Mobile";
import isMobile from "../utils/isMobile";
import { MainLayout } from "./main.layout";
import { Splash } from "./splash";

export const Loader: React.FC<{ bootsrapped: boolean }> = ({ bootsrapped }) => {
  const config: ConfigInit = useSelector((state: any) => state.ConfigState);
  const loginParam = UIService.getLoginParam();
  const iranLeagueParam = UIService.getLoginParam("irl");

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(HttpCacheAction.cleanUp());
    dispatch(UserSessionAction.hideLoading());
  }, [dispatch]);

  useEffect(() => {
    dispatch(ConfigInitAction.getData(loginParam, iranLeagueParam));
  }, [dispatch, loginParam, iranLeagueParam]);

  if (bootsrapped && !config.loading) {
    return (
      <ConnectedRouter history={history}>
        {isMobile.any() ? <Mobile /> : <MainLayout />}
      </ConnectedRouter>
    );
  }

  return <Splash />;
};
